<template>
    <section>
        <div>
            <div class="t-body3 mgt-6 t-color-content1">
                {{$t('16')}}
                <!-- 계정을 검색하려면 이메일 주소 또는 휴대폰 번호를 입력하세요. -->
            </div>
            <form @submit.prevent="searchInfo" novalidate>

                <div class="mgt-38">
                    <div class="mdc-text-field mdc-text-field--outlined w-full"
                        :class="submitState && lastNameInvalidCheck ? 'mdc-text-field--invalid' : ''"
                        id="lastNameValueEl"
                    >
                        <input type="text" class="mdc-text-field__input"
                            id="lastName"
                            name="lastName"
                            v-model="lastName"                            
                            v-validate="'required'"
                            ref="lastName"
                            maxlength="50"
                        >
                        <div class="mdc-notched-outline">
                            <div class="mdc-notched-outline__leading"></div>
                            <div class="mdc-notched-outline__notch">
                            <label for="tf-outlined" class="mdc-floating-label">
                                {{ $t('17') }}
                                <!-- 휴대폰 번호 또는 이메일 주소 -->
                            </label>
                            </div>
                            <div class="mdc-notched-outline__trailing"></div>
                        </div>
                        
                    </div>
                    
                    <div class="t-helper t-color-red1 mgl-7 mgr-7 pdt-2 min-h-23">
                        <span v-show="submitState && lastNameInvalidCheck">
                            {{$t('949')}}
                            <!-- * 휴대폰 번호 또는 이메일 주소를 입력하세요. -->
                        </span>
                    </div>
                </div>

                <div class="mgt-38">
                    <div class="mdc-text-field mdc-text-field--outlined w-full"
                        :class="submitState && firstNameInvalidCheck ? 'mdc-text-field--invalid' : ''"
                        id="firstNameValueEl"
                    >
                        <input type="text" class="mdc-text-field__input"
                            id="firstName"
                            name="firstName"
                            v-model="firstName"                            
                            v-validate="'required'"
                            ref="firstName"
                            maxlength="50"
                        >
                        <div class="mdc-notched-outline">
                            <div class="mdc-notched-outline__leading"></div>
                            <div class="mdc-notched-outline__notch">
                            <label for="tf-outlined" class="mdc-floating-label">
                                {{ $t('18') }}
                                <!-- 휴대폰 번호 또는 이메일 주소 -->
                            </label>
                            </div>
                            <div class="mdc-notched-outline__trailing"></div>
                        </div>
                        
                    </div>
                    
                    <div class="t-helper t-color-red1 mgl-7 mgr-7 pdt-2 min-h-23">
                        <span v-show="submitState && firstNameInvalidCheck">
                            {{$t('950')}}
                            <!-- * 휴대폰 번호 또는 이메일 주소를 입력하세요. -->
                        </span>
                    </div>
                </div>

                <div class="mgt-38">
                    <div class="mdc-text-field mdc-text-field--outlined w-full"
                        :class="submitState && codeInvalidCheck ? 'mdc-text-field--invalid' : ''"
                        id="codeValueEl"
                    >
                        <input type="text" class="mdc-text-field__input"
                            id="code"
                            name="code"
                            v-model="code"                            
                            v-validate="'required'"
                            ref="code"
                            maxlength="50"
                        >
                        <div class="mdc-notched-outline">
                            <div class="mdc-notched-outline__leading"></div>
                            <div class="mdc-notched-outline__notch">
                            <label for="tf-outlined" class="mdc-floating-label">
                                {{ $t('19') }}
                                <!-- 휴대폰 번호 또는 이메일 주소 -->
                            </label>
                            </div>
                            <div class="mdc-notched-outline__trailing"></div>
                        </div>
                        
                    </div>
                    
                    <div class="t-helper t-color-red1 mgl-7 mgr-7 pdt-2 min-h-23">
                        <span v-show="submitState && codeInvalidCheck">
                            {{ $t('953') }}
                            <!-- * 휴대폰 번호 또는 이메일 주소를 입력하세요. -->
                        </span>
                    </div>
                </div>

                <div class="mgt-38">
                    <button class="mdc-button mdc-button--raised btn-red">
                        {{$t('20')}}
                        <!-- 검색 -->
                    </button>
                    <button class="mdc-button btn-white mgr-8 mgl-8" @click="cancelFindCode()" type="button">
                        {{$t('21')}}
                        <!-- 취소 -->
                    </button>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import {findIdMixin} from '@/mixins/findId.js'
import findApi from '@/api/findApi.js'
import {mapState, mapMutations} from 'vuex'

export default {
    mixins: [findIdMixin],
    data() {
        return {
            firstName: '',
            lastName: '',
            code: '',
            submitState: false,
            firstNameTextField: '',
            lastNameTextField: '',
            codeTextField: '',
            externalAuthCode: false,
        }
    },
    mounted() {
        this.setMaterialUi()        
        //Store 초기화(init store)
        this.INIT_FINDPW_STORE()
        this.$refs.lastName.focus()
    },

    computed: {
        firstNameInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('firstName')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }
            
            this.firstNameTextField.valid === !returnValue ? '' : this.firstNameTextField.valid = !returnValue
            return returnValue
        },

        lastNameInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('lastName')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }

            this.lastNameTextField.valid === !returnValue ? '' : this.lastNameTextField.valid = !returnValue
            return returnValue
        },

        codeInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('code')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }

            this.codeTextField.valid === !returnValue ? '' : this.codeTextField.valid = !returnValue
            return returnValue
        }
    },

    methods: {
        // Store 변이 정의(define store mutation)
        ...mapMutations('findId', ['SET_STEP1', 'SET_AUTH_METHODS', 'INIT_FINDPW_STORE']),

        setMaterialUi() {
            this.firstNameTextField = new MDCTextField(document.querySelector('#firstNameValueEl'))
            this.firstNameTextField.useNativeValidation = false

            this.lastNameTextField = new MDCTextField(document.querySelector('#lastNameValueEl'))
            this.lastNameTextField.useNativeValidation = false

            this.codeTextField = new MDCTextField(document.querySelector('#codeValueEl'))
            this.codeTextField.useNativeValidation = false

            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        // search information
        searchInfo() {
            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    // this.callLoginApi(loginType)
                    let params = {
                        value: '',
                        firstName: this.firstName,
                        lastName: this.lastName,
                        code: this.code,
                    }

                    this.SET_STEP1(params)
                    // 패스워드 찾을 인증 수단 조회(get find password auth methods)
                    findApi.findByInfo(params).then((response) => {
                        let responseData = response.data.data
                        
                        this.SET_AUTH_METHODS(responseData)

                        if (responseData.length) {
                            this.$router.push({
                                name: 'FindIdStep3'
                            })
                        }else {
                            // this.errorModal({title:'검색 결과 없음', content: '검색하신 내용을 찾을 수 없습니다. 다른 정보를 이용해 다시 검색해주세요.'}).then(() => {})
                            this.$snackOpen({
                                contents: this.$t('29') +' '+ this.$t('30'),
                                btnDisplayYN: false
                                // btnDisplay:this.$t('Common.00001')
                            }).then(() => {})
                            
                        }
                        
                        
                    }).catch((err) => {
                        let responseData = err.response.data.meta
                        // this.errorModal({title:'검색 결과 없음', content: '검색하신 내용을 찾을 수 없습니다. 다른 정보를 이용해 다시 검색해주세요.'}).then(() => {})
                        // this.$snackOpen({contents:'검색 결과가 없습니다. 검색하신 이메일 주소 또는 휴대폰 번호를 확인 후 다시 시도해주세요.'}).then(() => {})
                        this.$snackOpen({
                            contents: this.$t('29') +' '+ this.$t('30'),
                            btnDisplayYN: false
                        }).then(() => {})
                        
                    })
                }else {
                    
                }

                this.$refs.lastName.focus()
            })
        }
    }
}
</script>